import _get from 'lodash/get'
import _set from 'lodash/set'
import * as z from 'zod'

import { PET_CONSTANTS } from '@flows/configs/petHealth/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_chipped = (params: StepConfigParams) =>
  ({
    schema: z.preprocess(
      (values: any) => {
        const chippedHelperPath = params.helperFunctions.getHelperPath('chipped')
        const chippedConfigValue = Boolean(
          _get(values, chippedHelperPath) === 'yes' ||
            _get(values, chippedHelperPath) === 'yes_later'
        )
        return _set(values, params.helperFunctions.getParamPath('chipped'), chippedConfigValue)
      },
      schemaUtils.generateZodObjectFromPaths({
        [params.helperFunctions.getHelperPath('chipped')]: z.enum(
          PET_CONSTANTS.helperChippedOptions
        ),
        [params.helperFunctions.getParamPath('chipped')]:
          BaseSchema_PetHealthV1GetsafeDe.shape.chipped.unwrap(),
      })
    ),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_chipped.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getHelperPath('chipped'),
        options: PET_CONSTANTS.helperChippedOptions.map((option) => {
          return {
            label: {
              type: 'translatableText',
              translationKey: `sharedFlows_petHealth:steps.pet_chipped.options.${option}`,
            },
            value: option,
          }
        }),
      },

      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chipped.infoBox.title',
            },
            isSmall: true,
          },
          {
            type: 'text',
            containsHTML: true,
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_chipped.infoBox.text',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getHelperPath('chipped'),
      valueToStepName: {
        yes: 'pet_chip_number',
        yes_later: 'pet_birthday',
        no: 'pet_birthday',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pet_chipped
